window._define('header', ['jquery', 'common/pubsub', 'utils/responsive', 'widgets/tabs', 'widgets/popOut'], function ($, pubsub, responsive, Tabs, PopOut) {
    var popOuts = [], currentWidth, mobileTabs, tabs, constants = { EVENT_OPENED_HEADER_MAIN_MOBILE_MENU: 'opened.header.main_mobile_menu' };

    var constantsWidth = {
        SCREEN_WIDTH_SMALL: 'small',
        SCREEN_WIDTH_MEDIUM: 'medium',
        SCREEN_WIDTH_LARGE: 'large',
        SCREEN_WIDTH_XLARGE: 'xlarge',
    };

    function toggleMobilePopOuts(width) {
        var enable = (width !== constantsWidth.SCREEN_WIDTH_MEDIUM || constantsWidth.SCREEN_WIDTH_SMALL);

        popOuts.forEach(function (popOut) {
            if (enable) {
                popOut.enable();
            } else {
                if (!popOut.element.data('keepItMobile')) {
                    popOut.disable();
                }
            }
        });
    }

    function toggleMobileTabs(width) {
        if (width === constantsWidth.SCREEN_WIDTH_MEDIUM || constantsWidth.SCREEN_WIDTH_SMALL) {
            tabs.enable();
        } else {
            tabs.disable();
        }
    }

    function toggleMobileNav(width) {
        if (width !== currentWidth) {
            toggleMobileTabs(width);
        }

        toggleMobilePopOuts(width);

        currentWidth = width;
    }

    currentWidth = responsive.getCurrentWidth();
    mobileTabs = $('.js-tabs-mobile');

    if (mobileTabs.length > 0) {
        tabs = new Tabs({
            isEnabled: (currentWidth === constantsWidth.SCREEN_WIDTH_MEDIUM || constantsWidth.SCREEN_WIDTH_SMALL),
        }, mobileTabs);

        $('.js-popOut-header').each(function (n, element) {
            popOuts.push(new PopOut({}, $(element)));
        });

        responsive.onChange(function (width) {
            toggleMobileNav(width);
        });

        toggleMobileNav(responsive.getCurrentWidth());
    }

    return constants;
});
